// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"416ac153d1186ccde270","966":"1ea2c1e9a6bfea891f89"}[chunkId] + ".js";
};